module.exports = __webpack_public_path__ + "static/favicon-d28856b735a19086a40b3bf22d2d2a1e.ico";